import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faLightbulb } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components/macro";

const InformationBubbleContainer = styled.span(
  ({ theme: { colors, fontWeights, fontSizes, radii, space } }) => `
  background-color: ${colors.surfaceBackground};
  border-radius: ${radii[4]}px;
  padding: ${space[1]}px;
  color: ${colors.titleMedium};
  font-weight:${fontWeights.normal};
  font-size:${fontSizes.alpha}px;
`,
);

export interface InformationBubbleProps {
  icon?: IconProp;
  message?: string;
}

export function InformationBubble(props: InformationBubbleProps) {
  const { icon = faLightbulb, message } = props;
  return (
    <InformationBubbleContainer>
      {icon && (
        <>
          <FontAwesomeIcon icon={icon} />
          &nbsp;
        </>
      )}
      {message && <span>{message}</span>}
    </InformationBubbleContainer>
  );
}
